export const FETCH_CATEGORY_GAME_COUNT = 'FETCH_CATEGORY_GAME_COUNT';
export const FETCH_CATEGORY_GAME_COUNT_SUCCESS = 'FETCH_CATEGORY_GAME_COUNT_SUCCESS';